export function formatFileSize(bytes: number): string {
	if (bytes < 1000000) return `${Math.round(bytes / 1000)}KB`;
	return `${Math.round(bytes / 1000000)}MB`;
}

export function formatFileInfo(bytes: number, type: string | undefined) {
	let fileType;
	if (type?.includes("javascript")) fileType = "JS";
	else if (type?.includes("zip")) fileType = "ZIP";

	if (fileType) {
		return `(${fileType}, ${formatFileSize(bytes)})`;
	} else {
		return `(${formatFileSize(bytes)})`;
	}
}

export function getAcceptedFileExtString(acceptedFileExt?: string[]) {
	if (!acceptedFileExt || acceptedFileExt.length === 0) {
		return "";
	}
	return acceptedFileExt.map((f) => `.${f.toLowerCase()}`).join(",");
}
